import {Component, EventEmitter, forwardRef, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';

@Component({
  selector: 'app-split',
  templateUrl: './split.component.html',
  styleUrls: ['./split.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => SplitComponent),
      multi: true
    }
  ]
})
export class SplitComponent implements OnInit, ControlValueAccessor {

  public form: FormGroup;
  public extra = false;
  public validExtra = true;
  @Output() validSuccess = new EventEmitter<any>();
  propagateChange = (_: any) => {};

  constructor(protected fb: FormBuilder) {
    this.createForm();
  }
  ngOnInit() {
  }

  /**
   * @Metodo createForm
   * @description crea el formulario y escucha los cambios
   * */
  createForm() {
    this.form = this.fb.group({
      separator: ['', [Validators.required, Validators.maxLength(3), Validators.minLength(1)] ],
      position: ['', [Validators.required]],
      ignorePart: ''
    });
    this.form.valueChanges.subscribe( val => {
      this.propagateChange(val);
      this.validFormSplit();
    });
    this.validControls();
  }

  /**
   * @Metodo validFormSplit
   * @description Emite la valides del form
   * */
  validFormSplit() {
    this.validSuccess.emit(this.form.valid);
  }

  /**
   * @Metodo validControls
   * @description para la validación de los campos
   * */
  validControls () {
    this.form.get('ignorePart').valueChanges.subscribe(value => {
      if (value === null) {
        this.form.controls['position'].setValidators([Validators.required]);
      } else {
        this.form.controls['position'].setValidators([]);
        this.form.controls['position'].setValue('');
      }
      this.form.controls['position'].updateValueAndValidity();
    });
  }

  /**
   * @Metodo createExtra
   * @description crea y muestra los campos Extras
   * */
  createExtra() {
    this.form.addControl('extraSeparator',
      this.fb.control('', Validators.required)
    );
    this.form.addControl('extraPosition',
      this.fb.control('', Validators.required)
    );
    this.extra = true;
    this.validExtra = false;
  }

  /**
   * @Metodo removeExtra
   * @description elimina los campos Extras
   * */
  removeExtra() {
    this.extra = false;
    this.validExtra = true;
    this.form.removeControl('extraSeparator');
    this.form.removeControl('extraPosition');
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState(isDisabled: boolean): void {
  }
  writeValue(obj: any): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/split/split.component.ts